/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:4afc50b4-8ce8-44d1-ba6d-61f7bdc4bc57",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_KgNGlUgwm",
    "aws_user_pools_web_client_id": "6eh71depki2bbnouhbd6a57c8s",
    "oauth": {
        "domain": "tm-service-gamma-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://gamma.transcript-manager.alexa.amazon.dev/",
        "redirectSignOut": "http://localhost:3000/,https://gamma.transcript-manager.alexa.amazon.dev/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
